<template>
  <div class="support-framework-parent flex flex-wrap">
    <div
      class="support-framework"
      v-for="item in options"
      :key="item.id"
      :class="{
        active: data.includes(item.id)
      }"
      @click="frameworkClick(item)"
    >
      <div class="triangle"></div>
      <span v-if="item.icon"> <img :src="item.icon" class="h-33px" /></span>
      <span v-else>{{ item.name }}</span>
      <div class="arrow" v-if="data.includes(item.id)">∨</div>
    </div>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'data',
    event: 'setData'
  },
  props: {
    data: {
      default: []
    }
  },
  data() {
    return {}
  },
  computed: {
    options() {
      return this.$store.state.selectOptions.frameWork
    }
  },
  methods: {
    // 支持框架 item点击
    frameworkClick(item) {
      this.$emit('item-click', item)
    }
  }
}
</script>
<style lang="scss" scoped>

.support-framework-parent {
  margin-top: -11px;
  .support-framework {
    border: 1px solid #e1dce9;
    min-width: 93px;
    height: 37px;
    padding: 5px 10px;
    display: flex;
    justify-content: center;
    border-radius: 5px;
    margin-right: 11px;
    margin-top: 11px;
    &.active {
      position: relative;
      border: 1px solid var(--primary-color);
      .triangle {
        width: 0;
        height: 0;
        position: absolute;
        right: -12px;
        bottom: -12px;
        border-top: 12px solid var(--primary-color);
        border-right: 12px solid transparent;
        border-bottom: 12px solid transparent;
        border-left: 12px solid transparent;
        transform: rotateZ(-45deg);
        font-size: 16px;
        color: #fff;
      }
      .arrow {
        position: absolute;
        right: 0px;
        bottom: -14px;
        font-size: 14px;
        color: #fff;
      }
    }
  }
}

</style>
